import { render } from "./producer-list.vue?vue&type=template&id=78ff7f16"
import script from "./producer-list.vue?vue&type=script&lang=js"
export * from "./producer-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__